import {
  OMSMetricsRequestSchema,
  SpendByCarrierResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getSpendByCarrier = {
  name: "getSpendByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: SpendByCarrierResponseSchema,
};
